module.exports = __webpack_public_path__ + "img/sign-in-alt.0aa54955.svg";